$(document).ready(function () {
  initPasswordStateToggle();

  function initPasswordStateToggle() {
    let passwordStateToggle = $('.js-password-input-toggle');

    if (!passwordStateToggle.length) {
      return;
    }

    passwordStateToggle.click(function (e) {
      e.preventDefault();

      let inputPassword = $(this).parents('[data-password-field]').find('input');

      if (!inputPassword.length) {
        return;
      }

      $(this).toggleClass('active');

      if (inputPassword.attr('type') === 'password') {
        inputPassword.attr('type', 'text');
      } else {
        inputPassword.attr('type', 'password');
      }
    });
  }
});